import {mapOverlayPanes} from "base/component/geo";
import {createLayerLegend, useLayerObject} from "base/map";
import {generatePopupHTML} from "app/common/PopupUtil";
import {formatNumber, formatUrl} from "app/common/TooltipUtil";

const MENU_ICON_SHAPE = "s";

const markerBaseOptions = {
    marker: MENU_ICON_SHAPE,
    fillColor: "#b4cbce",
    radius: 10,
    color: "#ffffff",
    addStroke: true,
    weight: 2,
    opacity: 1,
    fillOpacity: 1,
    lineJoin: "round",
    pane: mapOverlayPanes[2],
    interactive: false,
};

const eezFieldConfig = [
    {key: "country", label: "Country"},
    {
        key: "area_km2",
        label: "Area",
        format: value => formatNumber(value, "km²"),
    },
    {key: "political", label: "Political"},
    {key: "authority", label: "Authority", format: formatUrl},
    {key: "more_info", label: "More Info", format: formatUrl},
];

const createEezTooltip = data => {
    return generatePopupHTML("EEZ", data, eezFieldConfig);
};

export const LayerLegend = createLayerLegend({
    layerName: "EEZ",
    menuIconShape: MENU_ICON_SHAPE,
    defaultMarkerOptions: markerBaseOptions,
});

// eslint-disable-next-line no-unused-vars
export function useEezLayer(onSelectElement) {
    return useLayerObject({
        legend: LayerLegend,
        // metadata: "MARPLAN_Datos_Batimetria_01122023_MD.XML",
        detail: false,
        getTooltip: ({feature}) => {
            let data = feature.properties;
            return createEezTooltip(data);
        },
        // // TODO next methods are necessary for map inside EntityListMap
        // // We have to design this component without repeating if is from EntityListMap or MapProvider
        getCustomMarkerOptions: onSelectElement ? () => markerBaseOptions : null,
        defaultOnClick: ({feature}) => onSelectElement(feature.id),
    });
}
